import { ArrowUpRight } from "phosphor-react";

const SpeakerCardBackView = ({ speaker, onViewBio }) => {
  return (
    <>
      <div
        className="absolute inset-0 w-full h-full bg-[#11302D] flex flex-col  px-[30px] py-7 justify-between font-sora text-white
        pointer-events-none group-hover:pointer-events-auto
        overflow-y-auto"
        style={{
          transform: "rotateY(180deg)",
          backfaceVisibility: "hidden",
        }}
      >
        <div className="flex flex-col gap-3">
          <div>
            <h3 className="font-semibold md:text-[16px] leading-tight mb-2">
              {speaker.name}
            </h3>
            <p className="text-sm md:text-base font-medium italic mb-2 leading-tight">
              {speaker.title}
            </p>
          </div>
          <div className="flex items-center gap-2.5">
            <p className="bg-[#CBF07F] p-2.5 text-[#11302d] font-semibold text-xs">
              Session
            </p>
            <div className="h-px bg-[#CBF07F] flex-1" />
          </div>
          <p
            className="text-[#CBF07F] text-[20px] font-semibold  mb-6 tracking-[-2%] leading-tight"
            style={{ textWrap: "balance" }}
          >
            {Array.isArray(speaker.sessionTitle)
              ? `"${speaker.sessionTitle[0]}" and "${speaker.sessionTitle[1]}"`
              : `"${speaker.sessionTitle}"`}
          </p>
        </div>
        <button
          className="border border-[#CBF07F] text-[#CBF07F] px-4 py-4 font-medium flex justify-center items-center gap-3 cursor-pointer"
          onClick={() => {
            onViewBio(speaker);
          }}
          type="button"
        >
          View Full Bio
          <ArrowUpRight size={16} weight="bold" />
        </button>
      </div>
    </>
  );
};

export default SpeakerCardBackView;
